export var InflowStatus;
(function (InflowStatus) {
    InflowStatus["Pending"] = "pending";
    InflowStatus["Processed"] = "processed";
})(InflowStatus || (InflowStatus = {}));
